// extracted by mini-css-extract-plugin
export default {"price":"s7-z","onSale":"t7-z","msrpLabelPrice":"u7-z","msrpLabel":"v7-z","originalPrice":"w7-z","percentOff":"x7-z"};